import React from 'react';

import { BASE_ICONS } from 'src/components/svg';
import { popupModel } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { lang, withRouter } from 'src/helpers';

import AddLocation from 'src/components/location/AddLocation';
import LocationList from 'src/components/location/List';
import { MCButton } from 'src/components/basic';

import model from 'src/components/location/model';
import LANG_CONST from 'src/helpers/lang/const';

class Location extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  renderLocations = () => {
    return (
      <div className={'mc-setting-location mc-setting-form mc-grow'}>
        <div className={'mc-header'}>
          <div className={'mc-title'}>{lang.t(LANG_CONST.titles.locations)}</div>
          <MCButton
            primary
            light
            medium
            radius
            type={'button'}
            label={'Add new'}
            iconname={BASE_ICONS.PLUS}
            onClick={() =>
              popupModel.setActivePopup('add_location', {
                active: true,
                component: AddLocation,
                props: { model, addManager: !model.state.user?.isDoctor }
              })
            }
          />
        </div>
        <div className={'mc-container-content__body-content mc-p30 mc-grow'}>
          <LocationList showPagination={true} />
        </div>
      </div>
    );
  };

  render() {
    return <div className={'mc-main-content mc-flex-col'}>{this.renderLocations()}</div>;
  }
}

export default withRouter(Location);
